const YamParam = window.YAMASTERS_FRONTEND;

/**
 * Методы нужны для логики гугл капчи
 */
if (1) {
	var googleCaptcha = {
		/**
		 * Метод вызывается после успешной подгрузки гугл скриптов
		 * он запустит метод googleInvisibleCaptcha() который развесит всем нужным формам евенты
		 */
		googleStatus: function() {
			if (YamParam.debug) {
				console.log('googleStatus() // Метод вызван скриптом гугла, пнет метод для развески евентов');
			}

			if (1 // Перепроверка на то что бы было все необходимое для работы с капчей
			&& YamParam.googleInvisibleCaptcha
			&& YamParam.googleInvisibleCaptcha.publicKey) {
				googleInvisibleCaptcha();
			}
		},

		/**
		 * Метод развесит на все нужные формы евент для проверки капчи
		 */
		googleInvisibleCaptcha: function() {
			if (YamParam 
			&& YamParam.googleInvisibleCaptcha
			&& YamParam.googleInvisibleCaptcha.publicKey
			) {
				if (typeof grecaptcha === 'object') {
					if (YamParam.debug) {
						console.log('googleInvisibleCaptcha() // Метод вешает евенты на формы');
					}

					let forms = document.querySelectorAll('.gCheck');

					forms.forEach(function (form) {
						form.addEventListener('submit', function (e) {
							if (YamParam.debug) {
								console.log('googleInvisibleCaptcha()->evebtRun()');
							}

							// Евент
							e.preventDefault();

							// Создание контейнера
							e.target.googleContainer = document.createElement('div');

							window.googleFormFocus = e;

							// Параметры для запроса
							let renderOption = {
								sitekey: YamParam.googleInvisibleCaptcha.publicKey,
								size: 'invisible',
								theme: "light",
								tabindex: 9,
								callback: () => {
									if (typeof window.googleFormFocus === 'object') {
										window.googleFormFocus.target.submit();
										window.googleFormFocus = false;
									} else {
										if (YamParam.debug) {
											console.log("Error:: google.callback dont have event from storage 'googleFormFocus'");
										}
									}
								}
							};
							e.target.appendChild(e.target.googleContainer);
							grecaptcha.execute(grecaptcha.render(e.target.googleContainer, renderOption));
						});
					});
				} else {
					console.log('grecaptcha() is undefined');
				}
				
			} else {
				console.log('Google Invisible Captcha not work, need public key');
			}
		}
	};
}

/**
 * Методы нужны для корретной работы валидаторов на рекваер
 */
if (1) {
	var validate = function(e) {
		e.preventDefault();
		e.target.classList.add('errorFild');
		if (e.target.type === 'file') {
			parent = e.target.parentElement;
			if (parent.classList.contains('yamLabelFile')) {
				span = parent.querySelector('span');
				if (typeof span === 'object'){
					span.classList.add('noValidColor');
				}
			}
		}
	}
	var checkValidate = function(e) {
		e.preventDefault();
		var status;
		if (e.target.value !== '') {
			status = true;
			e.target.classList.remove('errorFild');
		} else {
			status = false;
			e.target.classList.add('errorFild');
		}

		if (e.target.type === 'file') {
			parent = e.target.parentElement;
			if (parent.classList.contains('yamLabelFile')) {
				span = parent.querySelector('span');
				if (typeof span === 'object'){
					if (status) {
						span.classList.remove('noValidColor');
					} else {
						span.classList.add('noValidColor');
					}
				}
			}
		}
	}
	/**
	 * При клике будет автоматом заполнеными первые символы
	 * @param e
	 */
	// var onFirstClick = function (selector) {
	// 	$(selector).on('click', function(e) {
	// 		var element = e.target;
	// 		if(!Boolean(element.value)){
	// 			// element.value = 123;
	// 			$(element).val(YamParam.mask.phone.valueDefault);
	// 		}
	// 	});
	// 	// window.yamtest = this;
	// }
}

// console.log(window.YAMASTERS_FRONTEND.validator.mask.email);
// console.log(window.YAMASTERS_FRONTEND.validator.mask.tel.default);

$('body').on('ajaxResponse', function() {
	/**
	 * проверка телефона браузером
	 */
	if (1) {
		var browserValidatePhone = function() {
			let inputTelephone = document.querySelectorAll('input:required');
			var regExpTel;
			var regExpMail;
			if(window.YAMASTERS_FRONTEND.validator.mask && window.YAMASTERS_FRONTEND.validator.mask.tel &&
				window.YAMASTERS_FRONTEND.validator.mask.tel.validator) {
				regExpTel = window.YAMASTERS_FRONTEND.validator.mask.tel.validator;
				// console.log(window.YAMASTERS_FRONTEND.validator.mask.tel.validator);
			} else {
				regExpTel = `\\+[0-9]{2}\\s\\([0-9]{3}\\)\\s[0-9]{3}\\s[0-9]{2}\\s[0-9]{2,6}`;
			}
			if(window.YAMASTERS_FRONTEND.validator.mask && window.YAMASTERS_FRONTEND.validator.mask.email &&
				window.YAMASTERS_FRONTEND.validator.mask.email.validator) {
				regExpMail = window.YAMASTERS_FRONTEND.validator.mask.email.validator;
			} else {
				regExpMail = `^([a-z0-9_-]+\\.)*[a-z0-9_-]+@[a-z0-9_-]+(\\.[a-z0-9_-]+)*\\.[a-z]{2,6}$`;
			}
			if(inputTelephone.length){
				inputTelephone.forEach(function(element) {
					// console.log(element, element.getAttribute('type') === "tel", element.className === "phone");
					//добавить проверку браузером телефон
					if(element.getAttribute('type') === "tel" || element.className === "phone"){
						// element.setAttribute('pattern', `\\+[0-9]{2}\\s\\([0-9]{3}\\)\\s[0-9]{3}\\s[0-9]{2}\\s[0-9]{2,6}`);
						element.setAttribute('pattern', regExpTel);
						// element.setAttribute('pattern', window.YAMASTERS_FRONTEND.validator.mask.tel.default);
					}
					//добавить проверку браузером мейл
					else if(element.classList.contains('email')){
						// element.setAttribute('pattern', `^([a-z0-9_-]+\\.)*[a-z0-9_-]+@[a-z0-9_-]+(\\.[a-z0-9_-]+)*\\.[a-z]{2,6}$`);
						element.setAttribute('pattern', regExpMail);
					}
				});
			}
		}
	}
	// Обвес евентов на гугл капчи
	if (1) {
		googleCaptcha.googleInvisibleCaptcha();
		googleCaptcha.googleInvisibleCaptcha();
	}
	// Обвес масок на формы
	if (window.YAMASTERS_FRONTEND !== undefined) {
		let phone = new Inputmask({
			mask: window.YAMASTERS_FRONTEND.validator.mask.tel.face,
			definitions: {
				'#': '',
				'^': {
					validator: "[0-9\\s]",
					cardinality: 1,
					casing: "lower"
				}
			},
			oncomplete: (e) => {
				// console.log(e.target);
				// console.log('tel oncomplete');
				e.target.classList.remove('onincomplete');
				e.target.classList.add('oncomplete');
			},
			onincomplete: (e) => {
				if($(e.target).attr('required')){
					e.target.classList.remove('oncomplete');
					e.target.classList.add('onincomplete');
					// e.target.value = '';
				}
			},
			oncleared: () => {
				// TODO:: СНести содержимое инпута
				console.log('tel oncleared');
				completePhone = false;
				clearIncomplete  = true;
			},
			// positionCaretOnClick: testMask()
		});

		let email = new Inputmask({
			mask: window.YAMASTERS_FRONTEND.validator.mask.email.face,
			greedy: false,
			definitions: {
				'*': {
					validator: "[0-9A-Za-z_-]",
					cardinality: 1,
					casing: "lower"
				},
				'@': {
					validator: '@',
					cardinality: 1,
					casing: 'lower'
				},
				'd': {
					validator: '.',
					cardinality: 1,
					casing: 'lower'
				}
			},
			oncomplete: (e) => {
				e.target.classList.remove('onincomplete');
				e.target.classList.add('oncomplete');
			},
			onincomplete: (e) => {
				if($(e.target).attr('required')){
					e.target.classList.remove('oncomplete');
					e.target.classList.add('onincomplete');
				}
			},
			oncleared: () => {
				completeEmail = false;
			}
		});
		phone.mask($('[type="tel"]'));
		phone.mask($('.phone'));
		if (typeof browserValidatePhone === 'function')
			browserValidatePhone();
		// onFirstClick('[type="tel"], .phone');
		email.mask($('.email'));
	}
	// Обвес методов для подсветки ошибок
	if (1) {
		var inputs = document.querySelectorAll(
        '#body input:required,' +
        '.formStandart input:required,' +
        '.formValidate input:required,' +
        '.popupForm input:required,' +
        '.popup-form input:required,' +
        '.formPopup input:required,' +
        'textarea:required,' +
        '.formWr input:required'
        );
		inputs.forEach(function(input) {
			input.addEventListener("invalid", validate);
			input.addEventListener("blur", checkValidate);
			if (input.type === 'file') {
				input.addEventListener('change', checkValidate);
			}
		});
	}
});


window.sendCaptcha = function (e, callBack) {
	if (YamParam.debug) {
		console.log('googleInvisibleCaptcha()->evebtRun()');
	}

	// Евент
	// e.preventDefault();

	// Создание контейнера
	let  googleContainer = document.createElement('div');

	window.googleFormFocus = e;

	// Параметры для запроса
	let renderOption = {
		sitekey: YamParam.googleInvisibleCaptcha.publicKey,
		size: 'invisible',
		theme: "light",
		tabindex: 9,
		callback: () => {
			if (typeof window.googleFormFocus === 'object') {
				// window.googleFormFocus.target.submit();
				window.googleFormFocus = false;
				callBack(grecaptcha.getResponse());
			} else {
				if (YamParam.debug) {
					console.log("Error:: google.callback dont have event from storage 'googleFormFocus'");
				}
			}
		}
	};

	// let tokenSave;
	e.appendChild(googleContainer);
	grecaptcha.execute(grecaptcha.render(googleContainer, renderOption));
}


// WEBPACK FOOTER //
// ./libs/validator.js